import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import ProfileAvatar from './ProfileAvatar';

export type NavProfileChipProps = {
  displayName: string;
  level: number;
  avatarId?: string;
  inMatch?: boolean;
  menu?: ReactNode;
};

export default function NavProfileChip({
  displayName,
  level,
  avatarId,
  inMatch = false,
  menu,
}: NavProfileChipProps) {
  return (
    <div className="flex items-center gap-2.5 sm:gap-3">
      <Link
        to={`/user/${displayName}?tab=overview`}
        className="group flex min-w-0 items-center gap-2.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-bk-gold"
        title="View profile"
      >
        <span className="relative shrink-0">
          <ProfileAvatar avatarId={avatarId} size="sm" />
          <span
            className="absolute -bottom-0.5 left-1/2 flex h-5 min-w-5 -translate-x-1/2 items-center justify-center rounded-full border border-bk-gold bg-bk-bg px-1 text-[10px] font-bold tabular-nums text-bk-text"
            title={`Level ${level}`}
          >
            {level}
          </span>
        </span>

        <span className="hidden min-w-0 flex-col leading-tight sm:flex">
          <span className="truncate text-sm font-semibold text-bk-text group-hover:text-bk-gold-bright">
            {displayName}
          </span>
          <span className="mt-0.5 flex items-center gap-1.5 text-[11px] font-medium uppercase tracking-wide">
            <span
              className={`h-1.5 w-1.5 shrink-0 rounded-full ${
                inMatch ? 'bg-bk-gold-bright' : 'bg-emerald-400'
              }`}
              aria-hidden
            />
            <span className={inMatch ? 'text-bk-gold' : 'text-emerald-400'}>
              {inMatch ? 'In Match' : 'Online'}
            </span>
          </span>
        </span>
      </Link>
      {menu}
    </div>
  );
}
